import { makeRequest } from "../utils/api";

export const getRequests = () => {
  return makeRequest(`/requests/`, "GET");
};

export const createRequest = (setError) => (values) => {
  return makeRequest(
    "/requests/",
    "POST",
    Array.isArray(values) ? values : [values],
    false,
    setError
  );
};

export const updateRequest =
  (setError) =>
  ({ requestId, from_date, to_date }) => {
    return makeRequest(
      `/requests/${requestId}/`,
      "PUT",
      { from_date, to_date },
      false,
      setError
    );
  };

export const deleteRequest = ({ requestId }) => {
  return makeRequest(`/requests/${requestId}/`, "DELETE");
};

export const updateAvailability =
  (setError) =>
  ({ availabilityId, hours }) => {
    return makeRequest(
      `/requests/availabilities/`,
      "PUT",
      [
        {
          availability_id: availabilityId,
          hours,
        },
      ],
      false,
      setError
    );
  };
